import { MbExpandablePanel } from '@am/moebius';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AdditionalCharge,
  AdditionalInformation,
  Breakdown,
} from '@core/models/breakdown/breakdown.interface';
import { HotelsService } from '@core/services/hotels.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'am-pricing-expandable',
  templateUrl: './pricing-expandable.component.html',
  styleUrls: ['./pricing-expandable.component.scss'],
})
export class PricingExpandableComponent implements OnInit, AfterViewInit {
  @ViewChild('contentTaxes', { static: false }) public panelTaxes: MbExpandablePanel;

  @Input() public rateId = '';
  @Input() public fop = '';
  @Input() public currencyCode = '';

  public breakdown: Breakdown;
  public rate: any;
  public charges: AdditionalCharge[];
  public information: AdditionalInformation;
  public currencySymbol: string;
  private suscriptions!: Subscription;

  constructor(private hotelsService: HotelsService, private cdr: ChangeDetectorRef) {}

  public ngOnInit() {}

  public ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  public getBreakdownHotel() {
    this.currencySymbol = this.currencyCode === 'USD' ? 'u$s' : '$';
    this.suscriptions = this.hotelsService
      .getHotelBreakdown(this.rateId, this.currencyCode)
      .subscribe((data) => {
        this.breakdown = data[0];

        if (this.breakdown !== undefined) {
          this.rate =
            this.fop === 'PAY_AT_DESTINATION'
              ? this.breakdown.price_clarification
              : this.breakdown.detail.rates[0];
          this.charges = this.breakdown.detail.charges;
          this.panelTaxes.expanded = true;
          if (this.breakdown?.additional_information) {
            this.information = this.breakdown?.additional_information[0];
          }
          this.cdr.detectChanges();
          this.suscriptions.unsubscribe();
        }
      });
  }

  public expand() {
    if (this.panelTaxes && this.breakdown === undefined) {
      this.getBreakdownHotel();
    } else {
      this.panelTaxes.expanded = true;
    }
  }

  public hiddenPane() {
    this.panelTaxes.expanded = false;
  }

  public resetBreakdown(): void {
    this.breakdown = undefined;
    this.rate = undefined;
    this.charges = undefined;
    this.information = undefined;

    if (this.panelTaxes) {
      this.panelTaxes.expanded = false;
    }

    this.cdr.detectChanges();
  }
}
